import { ICompany } from "models/HaulPay";

const SELF_FINANCE_NO_INVOICE_TO_NON_FACTORED_MODAL_ID = "self-finance-no-invoice-to-non-factored";

const createAbortError = () => {
  const error = new Error("The operation was aborted.");
  error.name = "AbortError";

  return error;
};

interface ConfirmSelfFinanceNoInvoiceToNonFactoredArgs {
  openModal: (modalId: string, props: Record<string, unknown>) => void;
  closeModal?: (modalId: string) => void;
  fromContractType?: string;
  toContractType?: string;
  signal?: AbortSignal;
}

export const confirmSelfFinanceNoInvoiceToNonFactored = ({
  openModal,
  closeModal,
  fromContractType,
  toContractType,
  signal
}: ConfirmSelfFinanceNoInvoiceToNonFactoredArgs) =>
  new Promise<ICompany>((resolve, reject) => {
    if (signal?.aborted) {
      reject(createAbortError());
      return;
    }

    let isSettled = false;

    const cleanupAbortListener = () => {
      if (signal && handleAbort) {
        signal.removeEventListener("abort", handleAbort);
      }
    };

    const settleResolve = (value: ICompany) => {
      if (isSettled) return;

      isSettled = true;
      cleanupAbortListener();
      resolve(value);
    };

    const settleReject = (reason: unknown) => {
      if (isSettled) return;

      isSettled = true;
      cleanupAbortListener();
      reject(reason);
    };

    const handleAbort = () => {
      closeModal?.(SELF_FINANCE_NO_INVOICE_TO_NON_FACTORED_MODAL_ID);
      settleReject(createAbortError());
    };

    signal?.addEventListener("abort", handleAbort, { once: true });

    openModal(SELF_FINANCE_NO_INVOICE_TO_NON_FACTORED_MODAL_ID, {
      fromContractType,
      toContractType,
      onConfirm: (debtor: ICompany) => {
        if (isSettled || signal?.aborted) {
          return;
        }

        settleResolve(debtor);
      },
      onCloseModal: () => {
        if (isSettled || signal?.aborted) {
          return;
        }

        settleReject("cancel-edit-fr");
      }
    });
  });
